import React, { useCallback, useEffect, useState } from "react";
import { message, Tooltip } from "antd";

import { WrappedFormRequirementType } from "./formRequirementType";
import { select, remove } from "../actions/dimensionsAndType";
import { downloadFile } from "../../../components/util";
import { ColumnProps, PaginationConfig, SorterResult } from "antd/lib/table";
import { IRequirementType, IRequirementTypeListResponse } from "./types";
import { Utilitaries } from "../../../business";
import {} from "./formRequirementType";
import { QmDimensionTable } from "./../components/qmTable";
import { ITableFilter, ITableSort, QmKeyObject } from "../components/types";

const listName = "tipos_requisitos";
const REPORT_PARAMS = {
    accao: "lista",
    lista: listName,
    campos: "designacao:400:Tipo de requisito;descricao:400:Descrição;",
    titulo: "Tipos de Requisitos",
};

export function RequirementType() {
    const [dataSource, setDataSource] = useState<IRequirementType[]>([]);
    const [loadingData, setLoadingData] = useState(true);
    const [showDeleteRecords, setShowDeleteRecords] = useState(false);
    const [filter, setFilter] = useState<ITableFilter>({
        pagination: {
            page: 1,
            perPage: 0,
        },
        filter: {},
    });

    const [editRow, setEditRow] = useState<IRequirementType | null>(null);
    const [showModalNew, setShowModalNew] = useState(false);

    /** get tipos requisitos from the server */
    const getRequirementType = useCallback(() => {
        setLoadingData(true);
        select({
            accao: "lista",
            lista: listName,
            pagina: 1,
            resultados_pagina: 0,
            mostra_lista_eliminados: showDeleteRecords,
        })
            .then((responses: IRequirementTypeListResponse) => {
                const list: IRequirementType[] = Utilitaries.toArray(responses.linha);
                const data = list.map((item) => {
                    return {
                        ...item,
                        designacao: typeof item.designacao === "object" ? "" : item.designacao,
                        descricao: typeof item.descricao === "object" ? "" : item.descricao,
                        versao: typeof item.versao === "object" ? "" : item.versao,
                    };
                });

                setDataSource(data);
                setLoadingData(false);
            })
            .catch(() => {
                message.error("Ocorreu um erro ao carregar os tipos de requisitos.");
            });
    }, [showDeleteRecords]);

    useEffect(() => {
        getRequirementType();
    }, [getRequirementType]);

    async function onExportList(type: "pdf" | "xls") {
        const params = {
            ...REPORT_PARAMS,
            filter,
            saida: type,
            downloadInBrowser: true,
        };
        await downloadFile("gerelistas.php", params);
    }

    function toggleShowDelete(value: boolean) {
        setShowDeleteRecords(value);
    }

    function handleNew() {
        setShowModalNew(true);
    }

    function handleCloseNew(reload?: boolean) {
        if (reload) {
            getRequirementType();
        }
        setShowModalNew(false);
    }

    function handleEdit(row: IRequirementType) {
        setEditRow(row);
    }

    function handleCloseEdit(reload?: boolean) {
        if (reload) {
            getRequirementType();
        }
        setEditRow(null);
    }

    function deleteRow(id: string) {
        remove({
            accao: "eliminar",
            lista: listName,
            chave1: id,
        }).then((sucess) => {
            if (sucess) {
                message.success("Linha eliminada com sucesso");
                getRequirementType();
            } else {
                message.error("Ocorreu um erro");
            }
        });
    }

    /** for search results in table */

    function handleTableChange(
        _: PaginationConfig,
        filters: Partial<Record<keyof IRequirementType, string[]>>,
        sorter: SorterResult<IRequirementType>
    ) {
        const objFilter: QmKeyObject = {};

        if (filters) {
            Object.entries(filters).forEach(([key, val]) => {
                if (val && val[0]) objFilter[key] = val[0];
            });
        }

        let sortObj: ITableSort | null = null;
        if (sorter.columnKey && sorter.order) {
            sortObj = {
                sorterBy: sorter.columnKey,
                sorterOrder: sorter.order,
            };
        }

        setFilter((state) => ({
            ...state,
            pagination: {
                ...state.pagination,
                page: 1,
            },
            filter: objFilter,
            sorter: sortObj ?? undefined,
        }));
    }
    /****************************** */

    const columns: ColumnProps<IRequirementType>[] = [
        {
            title: "Tipo de requisito",
            dataIndex: "designacao",
            width: "30%",
            ...QmDimensionTable.columnsSearch("designacao"),
        },
        {
            title: "Descrição",
            dataIndex: "descricao",
            width: "50%",
            ...QmDimensionTable.columnsSearch("descricao"),
            render: (text) => {
                return text && text.length >= 100 ? (
                    <Tooltip title={text}>
                        <div
                            style={{
                                textOverflow: "ellipsis",
                                width: " 500px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                            }}
                        >
                            {text}
                        </div>
                    </Tooltip>
                ) : (
                    <div>{text}</div>
                );
            },
        },
        {
            title: "Ações",
            dataIndex: "actions",
            width: "20%",
            render: (_, record) =>
                record._eliminado_ === "t" ? (
                    <QmDimensionTable.actions
                        deleteRow={() => deleteRow(record.id_tipo_requisito)}
                        handleEdit={() => handleEdit(record)}
                    />
                ) : null,
        },
    ];

    return (
        <>
            <QmDimensionTable.list
                rowKey={(record) => record.id_tipo_requisito}
                loading={loadingData}
                columns={columns}
                dataSource={dataSource}
                exportList={onExportList}
                toogleShowDeletedRecords={toggleShowDelete}
                handleNew={handleNew}
                onChange={handleTableChange}
            />

            {showModalNew && <WrappedFormRequirementType onClose={handleCloseNew} />}
            {editRow && <WrappedFormRequirementType record={editRow} onClose={handleCloseEdit} />}
        </>
    );
}
